export const returnText = 'В случае оформления возврата до истечения 365 дней владения сертификатом, начисленные средства сгорают, а ранее выведенные средства вычитаются из суммы подлежащей к возврату.'

export const withdrawText = 'До истечения 365 дней владения сертификатом к выводу доступно не более 1/2 начисленных средств.'
